import { InboxOutlined } from '@ant-design/icons'
import { ReactNode } from 'react'
import styled from 'styled-components'
import Spacer from './display/Spacer'
import SubHeader from './display/SubHeader'

const StyledSubHeader = styled(SubHeader)`
  min-height: 32px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    margin-bottom: 8px;

    > * {
      margin: 4px 0;
    }
  }
`

const TitleContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
`

const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media (max-width: 768px) {
    width: auto !important;
    margin-left: auto;
  }
`

interface ListPageHeaderProps {
  title?: ReactNode
  actions?: ReactNode
}

const ListPageHeader = ({ title, actions }: ListPageHeaderProps) => {
  return (
    <StyledSubHeader>
      <TitleContainer>
        <InboxOutlined />
        {title}
      </TitleContainer>
      <Spacer />
      {actions && <ActionsContainer>{actions}</ActionsContainer>}
    </StyledSubHeader>
  )
}

export default ListPageHeader
